import { useTranslation } from "react-i18next";
import TableHeaderSortingButton from "../../../../../../../shared/components/button/TableHeaderSortingButton";
import { DataTable } from "../../../../../../../shared/components/data-table/DataTable";
import TableDeleteButton from "../../../../../../../shared/components/button/TableDeleteButton";
import UpdatePlatformClientMappingDialog from "./UpdatePlatformClientMappingDialog";

const PlatformsClientMappingTable = ({
  data,
  onPlatformMappingEdition,
  onPlatformMappingDeletion,
}) => {
  const { t } = useTranslation();

  const columns = [
    {
      accessorKey: "platform",
      header: ({ column }) => {
        return (
          <TableHeaderSortingButton
            column={column}
            headerText={t(
              "clients.detail.tabs.platformMappings.table.platform",
            )}
          />
        );
      },
      cell: ({ row }) => row.original.platform.name,
    },
    {
      accessorKey: "code",
      header: ({ column }) => {
        return (
          <TableHeaderSortingButton
            column={column}
            headerText={t("clients.detail.tabs.platformMappings.table.code")}
          />
        );
      },
    },
    {
      id: "actions",
      cell: ({ row }) => {
        const data = row.original;
        return (
          <div className="flex flex-row justify-end pr-5">
            <UpdatePlatformClientMappingDialog
              id={data.id}
              platformMapping={data}
              onSubmitHandler={(formValues) =>
                onPlatformMappingEdition(data.id, formValues)
              }
            />
            <TableDeleteButton
              onClickHandler={() => onPlatformMappingDeletion(data.id)}
            />
          </div>
        );
      },
    },
  ];

  return <DataTable data={data} columns={columns} />;
};

export default PlatformsClientMappingTable;
